// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"72":"32b6bb55","258":"a80c94ae","261":"6ac07aae","453":"1668c08b","635":"7e31bd81","743":"0af19222","750":"6ff58c7e","754":"b01bbf0e","851":"c5f10d3d","859":"f8cbc73d","906":"0f86c6f3","908":"eeb803e5","913":"1195d376","919":"337d116e","993":"fee182c2"}[chunkId] + ".chunk.js";
};